import React from "react"
import api from "src/api"
import {getPaymentTypes} from "../../../utils";
import {notification} from "antd";

export function useGetOrders() {
  const [items, setItems] = React.useState([])
  const [pagination, setPagination] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(false)


  async function getItems(activeTabKey, page = 1, countOnPage = 20) {
    setIsLoading(true)
    let filterData = {}
    switch (activeTabKey) {
      case "inProcessing":
        filterData.orderStatusId = 2;
        break;
      case "paid":
        filterData.orderStatusId = 4;
        break;
      case "awaitingPayment":
        filterData.orderStatusId = 8;
        break;
      case "errorOfd":
        filterData.isSaveOfd = false;
        filterData.isRegOfd = false;
        break;
      case "errorTily":
        filterData.isPaid = true;
        break;
    }

    try {
      const {data} = await api.post(
        `orders/filter?page=${page}&countOnPage=${countOnPage}`,
          filterData
      )
      if (data.pagination) {
        setPagination({
          current: data.pagination.currentPage,
          pageSize: data.pagination.countOnPage,
          total: data.pagination.total,
        })
      }
      setItems(data.items)
    } catch (error) {
      console.error("error get orders", error)
    } finally {
      setIsLoading(false)
    }
  }

  function handleTableChange(paginationData, status) {
    getItems(status, paginationData.current, paginationData.pageSize)
  }

  async function handleClearSchedulerCache() {

    try {
      await api.get('clear-scheduler-cache')

      notification.success({message: 'Кеш очищен'})
    } catch (error) {
      notification.error({message: 'Кеш очищен'})
    }
  }

  /*async function getDataPaymentTypes() {
    const types = await getPaymentTypes()
    const newItems = types.map((item) => {
      return {
        label: item.name.find((el) => el.language === "ru").content,
        value: item.id
      }
    })
    setPaymentTypes(newItems)
  }
  async function getDeliveryTypes() {
    try {
      const { data } = await api.get("delivery-types")
      const options = data.items.map((item) => ({
        ...item,
        nameRu: item?.name?.find((el) => el.language === "ru").content,
      }))
      setDeliveryTypes(options)
    } catch (error) {
      console.error(error)
    }
  }*/

  return {
    items,
    pagination,
    isLoading,
    getItems,
    /*options: { deliveryTypes, paymentTypes },*/
    handleTableChange,
    handleClearSchedulerCache
    /*handleSearchTable,
    handleClearFilter,
    handlePaymentCheck,
    resendToCrm*/
  }
}

export function getFormattedItems(items) {
  const data = items.map((item) => ({
    key: item.dashboardOrder.id,
    phone: item.dashboardUser.phone,
    outNumber: item.dashboardOrder.outNumber,
    externalGuid: item.dashboardOrder.externalGuid,
    isNeedAccept: item.dashboardOrder.isNeedAccept,
    isPaid: item.dashboardOrder.isPaid,
    id: item.dashboardOrder.id,
    innerId: item.dashboardOrder.innerId,
  }))

  return data
}
